import React, { useState } from 'react'
import { Trans, useTranslation } from "react-i18next";
import logIN from "../../../assets/images/customer_login.svg";
import eyeIcon from "../../../assets/images/eyeicon.svg";
import eyeiconunfold from "../../../assets/images/eyeiconunfold.svg";
import elogIN from "../../../assets/images/expert_login.svg";
import ilogIN from "../../../assets/images/institution_login.svg";
import env from "../../../assets/Instituteppvimages/mail-pencil.svg"
import { Link, useHistory } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { getRoute } from '../../../shared/helper';
import { Footer } from '../../common/footer/footer';
import styles from './login.module.css';
const LoginJsx = (props) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState({});
  const toggleShowPassword = (fieldName) => {
    setShowPassword(prevState => ({
      ...prevState,
      [fieldName]: !prevState[fieldName]
    }));
  };

  const history = useHistory();
  const {
    onInputChangeHandler,
    onTouchHandler,
    formSubmitButtonDisable,
    formError,
    formSubmitHandler,
    isLoading,
    isFirstTime,
    onFirstLoginClick, selectedType
  } = props;

  return (
    <>
      <section className="mainloginscreen">
        <div className="container">
          <div className={`${styles.mainloginscreeninner}`}>
            <ul className={`d-flex justify-content-center`}>
            <li className={`${selectedType === "customer" ? 'active' : ''}`}>
                <Link to="/login/customer" className={`logincs`}
                >
                  <div className={`${styles.loginscreenimage} d-flex align-items-center`}>
                    <figure><img src={logIN} alt={'loginimage'} /></figure>
                    <figcaption>
                      <h3>{t("LOGIN.CUSTOMERTITTLE")}</h3>
                      <p><Trans>{t("LOGIN.CUSTMERSUBTITTLE")}</Trans></p>
                    </figcaption>
                  </div>
                </Link>
              </li>
             
              <li className={`${selectedType === "expert" ? 'active' : ''}`}>
                <Link to="/login/expert" className={`logincs`}
                >
                  <div className={`${styles.loginscreenimage} d-flex align-items-center`}>
                    <figure><img src={elogIN} alt={'loginimage'} /></figure>
                    <figcaption>
                      <h3>{t("LOGIN.EXPERTTITTLE")}</h3>
                      <p><Trans>{t("LOGIN.EXPERTSUBTITTLE")}</Trans></p>
                    </figcaption>
                  </div>
                </Link>
              </li>
              <li className={`${selectedType === "institute" ? 'active' : ''}`}>
                <Link to="/login/institute"
                  className={`logincs`}
                >
                  <div className={`${styles.loginscreenimage} d-flex align-items-center`}>
                    <figure><img src={ilogIN} alt={'loginimage'} /></figure>
                    <figcaption>
                      <h3>{t("LOGIN.INSTITUTETITTLE")}</h3>
                      <p><Trans>{t("LOGIN.INSTITUTESUBTITTLE")}</Trans></p>
                    </figcaption>
                  </div>
                </Link>
              </li>
            </ul>
          </div>


          <div className={`${styles.formsection} ${selectedType}`}>
            <div className={`${styles.institutelogintext}`}>
              <h2 className="h2_style text-center">{selectedType === "institute" ? "Institution" : selectedType === "expert" ? "Expert" : "Customer"} {t("COMMON.LOGIN")}</h2>
              <h6 className="h6_style text-center">{t("LOGIN.SUB_TITLE")}</h6>
              <div className={`${styles.formsectioninner}`}>
                
                <div className={`mb-4 input-container form-group ${styles.formfield} ${selectedType}`}>
                  <p className={`${styles.smalltext} mt-3`}>{t("LOGIN.DESCRIPTION")}</p>
                  <input
                    onChange={onInputChangeHandler}
                    onBlur={onTouchHandler}
                    required
                    type={'email'}
                    placeholder={`${selectedType} ${t("Login Email*")}`}
                    className={
                      formError['email']
                        ? "input form-control  is-invalid"
                        : "input form-control"
                    }
                    id={'email'}
                    name={'email'}
                    maxLength={50}

                  />
<span className={`${styles.form_image} form_imageglobal`}><img src={env} alt={'formimage'} /></span>

                  <span className="text-danger">
                    {
                      formError['email'] &&
                      (formError['email'] === "req"
                        ? t('Email is required!')
                        : t('Enter a valid email address.'))}
                  </span>

                </div>

                {
                  isFirstTime && <button type="submit" className='mt-4 ctatwobutton' onClick={onFirstLoginClick}>{t("COMMON.NEXT")}</button>
                }

                {!isFirstTime && <div className={`mb-4 input-container form-group ${styles.formfield}`}>
                <p className={`${styles.smalltext} mt-3`}>{t("LOGIN.Enter_Password")}</p>
                <input
  onChange={onInputChangeHandler}
  onBlur={onTouchHandler}
  required
  type={showPassword['password'] ? 'text' : 'password'}
  placeholder={t('Enter Password')}
  className={
    formError['password']
      ? 'input form-control is-invalid'
      : 'input form-control'
  }
  id="password"
  name="password"
  maxLength={16}
/>
<span
  className={`${styles.form_image} form_imageglobal`}
  onClick={() => toggleShowPassword('password')}
  style={{ cursor: 'pointer' }}
>
  {showPassword['password'] ? (
    <img alt="Hide password" src={eyeiconunfold} />
  ) : (
    <img alt="Show password" src={eyeIcon} />
  )}
</span>

                  <span className="text-danger">
                    {
                      formError['password'] &&
                      (formError['password'] === "req"
                        ? t('Password is required!')
                        : t('Enter a valid Password.'))}
                  </span>

                </div>
                }
                {!isFirstTime && <> <div id="forgetpass" className="form-text" onClick={(e) => { history.push('/forgotPassword'); localStorage.setItem('requestType', 'forgot-password'); localStorage.setItem('flowName', 'login'); localStorage.setItem('flowType', selectedType === "institute" ? "institute" : selectedType === "expert" ? "expert" : "customer") }}>{t("LOGIN.FORGOT")}</div>                  <button type="submit" className={
                  formSubmitButtonDisable
                    ? "btn-secondary btn mt-4 ctatwobutton"
                    : "mt-4 ctatwobutton"
                }
                  onClick={formSubmitHandler}
                  disabled={formSubmitButtonDisable}>{isLoading ? t("COMMON.PROCESSING") : t("COMMON.LOGIN")}</button></>}
                <div className={`${styles.form_text} mt-3 text-center`}>{t("LOGIN.IS_ACCOUNT")} </div>
                {selectedType === "customer" && <Link className={`mt-4 ${styles.ctaonebutton}`} to={getRoute('customer', 'login')}>Register Now</Link>
                }
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </section>
      <ToastContainer />

    </>

  );
};

export default LoginJsx;
